import React from 'react';
import { lifestyleGallery } from '../data/mock';
import useReveal from '../hooks/useReveal';
import { useSiteMedia } from '../utils/useSiteMedia';
import { fitToClass } from '../utils/mediaFit';

const LifestyleGallery = () => {
  const [gridRef, gridVisible] = useReveal();
  const [headRef, headVisible] = useReveal();
  const slot = useSiteMedia('home_lived_in');
  const adminTiles = (slot?.media || []).map((m) => ({ src: m.url, alt: m.alt || '', fit: m.fit || 'cover' }));
  const tiles = adminTiles.length > 0 ? adminTiles : lifestyleGallery.map((t) => ({ ...t, fit: 'cover' }));
  return (
    <section className="bg-[#F5EDDD] py-16 md:py-20">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <div
          ref={headRef}
          className={`reveal ${headVisible ? 'in' : ''} flex items-end justify-between mb-12`}
        >
          <div>
            <p className="text-[11px] tracking-[0.32em] uppercase text-[#A07A4F] mb-3">— Lived in</p>
            <h2
              className="text-4xl md:text-5xl text-[#33200F]"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              In real <span className="italic text-[#5B3A24]">homes</span>.
            </h2>
          </div>
          <p className="hidden md:block max-w-sm text-[#5B3A24] text-[14px] leading-[1.85]">
            Pieces that look better in real living rooms than in showrooms.
          </p>
        </div>

        <div
          ref={gridRef}
          className={`reveal-stagger ${gridVisible ? 'in' : ''} grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6`}
        >
          {tiles.map((t, i) => (
            <div
              key={i}
              className="relative aspect-[4/5] overflow-hidden bg-[#EDE3CF] group"
            >
              <img
                src={t.src}
                alt={t.alt || `Lifestyle photograph — Timber & Thread Co. in real homes ${i + 1}`}
                loading="lazy"
                decoding="async"
                className={`w-full h-full ${fitToClass(t.fit)} image-zoom`}
              />
              <div className="absolute inset-0 bg-[#1E140B]/0 group-hover:bg-[#1E140B]/15 transition-colors" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LifestyleGallery;
